import React from "react";
import "./Home.css";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import Hero from "../Hero/Hero";
import OneClickSection from "../OneClickSection/OneClickSection";
import Services from "../Services/Services";
import Banner from "../Banner/Banner";
import Process from "../Process/Process";
import Strategies from "../Strategies/Strategies";
import WhyChooseUs from "../WhyChooseUs/WhyChooseUs";

const fade = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] } },
};

const Home = () => {
  return (
    <main className="home-wrapper">
      <section className="home-section hero-section" aria-label="Hero">
        <Hero />
      </section>

      <section className="home-section seo-lead" aria-labelledby="seo-lead-heading">
        <motion.div
          className="seo-lead__inner"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.35 }}
          variants={fade}
        >
          <h2 id="seo-lead-heading">A Dallas digital marketing studio for teams that want clarity</h2>
          <p>
            <strong>smartprintersolutions.com</strong> helps businesses plan and run full-funnel digital marketing—
            from search engine optimization and Google Ads to social campaigns, email lifecycle programs, and analytics
            dashboards. Every engagement starts with written goals, budgets, and deliverables so you know what we
            control versus what platforms decide.
          </p>
          <p>
            Whether you need a one-time SEO audit, ongoing paid media management, or a multi-channel growth plan, we
            focus on transparent reporting and policy-friendly messaging. We do not promise #1 rankings, fixed CPA, or
            guaranteed revenue—because honest marketing outperforms hype over time.
          </p>
          <p className="seo-lead__links">
            Learn more about our <Link to="/services">digital marketing services</Link>,{" "}
            <Link to="/process">delivery process</Link>, or <Link to="/about">about our team</Link>.
          </p>
        </motion.div>
      </section>

      <section className="home-section light-section">
        <OneClickSection />
      </section>

      <section className="home-section">
        <Services />
      </section>

      <section className="home-section band-section">
        <Banner />
      </section>

      <section className="home-section light-section">
        <Process />
      </section>

      <section className="home-section">
        <Strategies />
      </section>

      <section className="home-section light-section">
        <WhyChooseUs />
      </section>
    </main>
  );
};

export default Home;
